module.exports = __webpack_public_path__ + "static/img/1.60f8328.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/channel/icon/1.png
// module id = CzrR
// module chunks = 1